import React, {Component} from 'react';

class SearchResult extends Component {
  render(){
    if(this.props.keyword === ""){
      return(
        <p className="pgh-result-01">キーワードを入力して検索してください。</p>
      )
    }else{
      return(
        <p className="pgh-result-01">
          <strong>"{decodeURI(this.props.keyword)}"</strong> を含む検索結果は<em>{this.props.itemsLength}</em>件です。
        </p>
      )
    }
  }
}

export default SearchResult